import React from 'react'
import { connect } from 'react-redux'
import { Card } from '../common/Layout'
import { TextField, InputError } from '@foodsby/nutrient'
import { reduxForm, Field } from 'redux-form'
import { email } from 'redux-form-validators'
import { Submitting } from '../common/Submitting'
import { addFriendStart } from '../../redux/modules/friends'

// form that allows to send new friend requests to the API, visible on both the home page and the friend manager page
export const FriendRequestForm = ({
  handleSubmit,
  isAddingFriends,
  pristine,
  valid,
  success,
  invalid
}) => (
  <form onSubmit={handleSubmit}>
    <Field
      name="email"
      type="email"
      component={TextField}
      validate={email({ allowBlank: true })}
      label="Email:"
      placeholder="example@acme.com"
    />
    <div className="row center-xs">
      {isAddingFriends ? (
        <Submitting text="Invite" />
      ) : (
        <button className="primary" type="submit" disabled={pristine || !valid}>
          Invite
        </button>
      )}
      {success && success !== undefined && !invalid && pristine && (
        <div className="row center-xs middle-xs success">
          <i className="icon-check-circle" />
          &nbsp;Success
        </div>
      )}
    </div>
  </form>
)

export const ReduxFriendRequestForm = reduxForm({
  form: 'friendRequestForm'
})(FriendRequestForm)

// Component that shows on the Friends Manager page for inviting friends from the sidebar
const FriendRequestSidebar = ({
  addFriendStart,
  isAddingFriends,
  success,
  sendFriendRequestError
}) => {
  return (
    <Card>
      <div className="row center-xs friendsTitle">Invite Friends</div>
      <hr />
      <div className="row">
        <p className="col-xs-12 start-xs">
          Enter a friend/co-worker's email address to invite them to be your
          friend.
        </p>
      </div>
      <ReduxFriendRequestForm
        onSubmit={addFriendStart}
        isAddingFriends={isAddingFriends}
        success={success}
      />
      {sendFriendRequestError && (
        <InputError
          isOpened={sendFriendRequestError && sendFriendRequestError !== null}
        >
          {sendFriendRequestError}
        </InputError>
      )}
    </Card>
  )
}

const mapStateToProps = state => {
  const { isAddingFriends, success, sendFriendRequestError } = state.friends
  return {
    isAddingFriends,
    success,
    sendFriendRequestError
  }
}

const mapDispatchToProps = {
  addFriendStart
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FriendRequestSidebar)
